import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { accountSelectedSelector } from 'atoms';
import { useRecoilValue } from 'recoil';
import EventDetails from 'components/EventDetails';

function EventDetailsPage() {
  const { eventType, eventId } = useParams();
  const [searchParams] = useSearchParams();
  const occurrenceId = searchParams.get(`occurrenceId`);
  const accountSelected = useRecoilValue(accountSelectedSelector);

  if (!accountSelected) {
    return <Navigate to="/" />;
  }

  return (
    <EventDetails
      account={accountSelected}
      occurrenceId={occurrenceId}
      eventType={Number(eventType)}
      eventId={eventId}
    />
  );
}

export default EventDetailsPage;
